import { ActivityGame, GameMetadata } from "modules/games/game"
import { gamesLookupService } from "modules/games/games-lookup"
import React, { useCallback, useEffect, useState } from "react"
import { LessonActivityModel } from "modules/lesson/activity/lesson-activity"
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap"
import { LessonActivity } from "modules/lesson/activity/activity.types"
import { useNavigate } from "react-router-dom"
import { formatIsoDate } from "common/utils/date-utils"
import awicon from "assets/images/services-icon/coin.png"


type GameCardProp = {
  activity: LessonActivity
  studentKey?: string
  options?: {
    showStatus?: boolean
    showContextMenu?: boolean
    showDelete?: boolean
    index?: number
    onDelete?: () => Promise<void>
    showRollOverToNextSession?: boolean
    onRollOverToNextSession?: () => Promise<void>
    showRollOverFrom?: boolean
    showHighlight?: boolean
  }
  checkbox?: {
    checkable: boolean
    checked?: boolean
    onCheckedChanged?: () => unknown
  }
}


function findGameFromActivity(allGames: ActivityGame[], activity: LessonActivity) {
    for (const game of allGames) {
      if(game.id === activity.fk_activity_node_id) {
        return game;
      }
  }
  return null;
}

export const GameCard = ( {activity, options, checkbox, studentKey: activityStudentKey}: GameCardProp) => {

  const [game, setGame] = useState<ActivityGame | null>();
  const [contextMenuOpen, setContextMenuOpen] = useState(false);
  const navigate = useNavigate();

  const activityModel = new LessonActivityModel(activity);
  const total_coins = GameMetadata.coinsPerGame;

  useEffect(() => {
    async function getGames(){
      const _allGames = await gamesLookupService.getGames();

      const _game = findGameFromActivity(_allGames, activity);
      setGame(_game);
    }
    getGames().then();
  }, [])

  const navigateToGameSummary = useCallback(()=>{
    navigate(`/game-summary/${activity.pk_lesson_activity_key}`);
  }, [activity])

  function getHighlightColor(activityModel: LessonActivityModel) {
    if(!options?.showHighlight)
      return ""

    if(activityModel.isCompleted())
      return "activity-card-success"
    else
      return "activity-card-danger"

  }

  return <div className={`m-1 set1 bg-supermild ${getHighlightColor(activityModel)}`} style={{}}>
    <div className="d-flex justify-content-between">
      <div>
        {
          options?.showRollOverFrom && activityModel.getRollOverDate() !== null &&
          <span className="cs-txt-danger font-size-10 me-2">
            Rolled over from {formatIsoDate(activityModel.getRollOverDate())}
          </span>
        }

        {
          options?.showStatus &&
          <>
            { activityModel.isCompleted() &&
              <span className="text-success font-size-10 me-2">Completed</span>
            }
            {!activityModel.isCompleted() &&
              <span className="cs-txt-danger font-size-10 me-2">Incomplete</span>
            }
          </>
        }
      </div>

      {
        checkbox?.checkable &&
        <div>
          {
            (!activityStudentKey || activity.fk_student_key === activityStudentKey) &&
            <>
              <input
                type="checkbox"
                checked={checkbox.checked}
                onChange={checkbox.onCheckedChanged}
              />
            </>
          }
        </div>
      }
    </div>
    <p><b>{options?.index !== undefined ? options.index + 1 + ') ' : ''} Game: {game?.name}</b></p>
    <div className="d-flex justify-content-between">
      <div className="d-flex align-items-center fw-400 font-size-12 text-dark">
        {game?.description}
      </div>
      <div>
        {options?.showContextMenu &&
          <Dropdown
            isOpen={contextMenuOpen}
            toggle={() => setContextMenuOpen(!contextMenuOpen)}
          >
            <DropdownToggle className="p-0 bg-white">
              <i className="mdi mdi-dots-horizontal"></i>{" "}
            </DropdownToggle>
            <DropdownMenu className="custom-position">
              <DropdownItem disabled={!activityModel.isCompleted()}
                            onClick={navigateToGameSummary}>
              <span>
                <i className="mdi mdi-eye-outline font-size-15 me-1"></i>
              </span>{" "}
                Preview
              </DropdownItem>

              {activityModel.isCompleted() === false && options.showDelete &&
                <DropdownItem className="custom-position"
                              onClick={options?.onDelete}>
                  <span>
                    <i className="far fa-trash-alt font-size-15 me-1"></i>
                  </span>{" "}
                  Delete
                </DropdownItem>
              }

              {options.showRollOverToNextSession &&
                <DropdownItem className="custom-position"
                              onClick={options?.onRollOverToNextSession}>
                  <span>
                    <i className="mdi mdi-calendar-arrow-right font-size-15 me-1"></i>
                  </span>{" "}
                  Roll over to next session
                </DropdownItem>
              }
            </DropdownMenu>
          </Dropdown>
        }
      </div>
    </div>

    <div className="d-flex justify-content-center">
      <div className="mt-3" style={{ width: "90px", height: "90px" }}>
        <img src={game?.image} style={{ width: "100%", height: "100%" }} />
      </div>
    </div>

    <div className="d-flex justify-content-between">
      <div className="d-flex align-items-center font-size-12 text-dark fw-400">
      </div>

      <div className="d-flex align-items-center font-size-12 text-dark fw-400">
        {" "}
        <img className="me-10" width={24} src={awicon} alt=""/>
        {activityModel.getCoinsEarned() ? activityModel.getCoinsEarned(): 0}
        /
        {total_coins}
        {" "}
      </div>
    </div>
  </div>
}